import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { PermissionService } from './../../../../core/services/authentication/permission.service';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  NotificationsService,
  OrganizationsService,
} from '../../../../core/api/services';
import { AppNotificationService } from './../../../../core/services/app-notification.service';
import { TranslationModule } from './../../../../i18n/translation.module';
import { NotificationItemComponent } from './notification-item/notification-item.component';

@Component({
    selector: 'notifications',
    imports: [
        CommonModule,
        TranslationModule,
        NgbModule,
        NotificationItemComponent,
    ],
    templateUrl: './notifications.component.html'
})
export class NotificationsComponent {
  //#region properties

  appNotificationService = inject(AppNotificationService);
  notificationsService = inject(NotificationsService);
  organizationsService = inject(OrganizationsService);
  permissionService = inject(PermissionService);
  subscription: Subscription;
  loading: boolean;
  //#endregion

  //#region api

  getNotificationListApi() {
    this.appNotificationService.getNotificationsApi().subscribe();
  }

  notificationsSeenApi() {
    if (this.subscription) this.subscription.unsubscribe();
    this.loading = true;

    this.subscription = this.notificationsService
      .notificationsCreateNotificationsSeen({ body: {} })
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((res) => {
        if (res.isSucceed) this.getNotificationListApi();
      });
  }

  //#endregion

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
